<template>
  <div>
    <div class="msg">
      <div class="message_div">
        <div class="msg_left">
          <div class="msgname">
            <div class="msgname1"></div>

            <div class="clear_red_dot" @click="click_clear_red_dot">
              <span class="iconfont iconqingchu"></span>
              <!-- <span>清除小红点</span> -->
            </div>
          </div>
          <div @click="click_msg_card(item, i)" :class="user_index == i ? 'msg_card_select' : 'msg_card'"
            v-for="(item, i) in user_msg_list" :key="i">
            <div class="avatar">
              <img class="avatar_img" :src="item.avatar" alt="" />
            </div>
            <div>
              <div>
                <Badge :count="item.count" :offset="['+7', '8']" v-if="item.is_no_disturbing == 0">
                  <div class="msg_title">
                    <div>
                      {{ item.name }}
                    </div>
                  </div>
                </Badge>
                <div v-else>
                  <div class="msg_title-1">
                    <div>
                      {{ item.name }}
                    </div>
                    <Icon class="no_msg" title="消息免打扰" type="md-notifications-off" size="18" color="#ebd5c3" />

                  </div>

                </div>
                <div class="msg_detail">
                  {{ item.finally_msg_time_fmt }}
                </div>
              </div>
            </div>
            <div class="del_msg_list" @click.stop="click_del_msg(item)">
              <Icon type="md-close" class="del_msg_icon" />
            </div>
          </div>
        </div>
        <div class="msg_right">
          <!-- <div class="msg_bg">
            <img
              style="width: 300px; height: 55px"
              src="@/assets/image/auth/logo.png"
              alt=""
            />
          </div> -->
          <Spin fix v-if="msg_content_loading">
            <Icon type="ios-loading" size="28" class="demo-spin-icon-load"></Icon>
            <div style="margin-top: 15px">消息内容玩命加载中...</div>
          </Spin>

          <div class="msg_header">
            <div class="msg_header_title">
              {{ current_user_item.name }}
            </div>
            <div class="msg_header_detail">
              {{ current_user_item.detail }}
            </div>
          </div>

          <div class="msg_content" id="msg_content">
            <div class="msg_content_inner">
              <div v-for="(msg_info, msg_i) in msg_data_list" :key="msg_i">
                <div class="msg_time">
                  <span class="msg_time_span">{{ msg_info.send_time }}</span>
                </div>

                <div class="msg_content_inner2">
                  <!--左侧头像  -->
                  <div class="msg_content_left msg_time_cur">
                    <div class="msg_user_avatar" v-if="msg_info.status == 'receive'">
                      <img style="width: 100%; height: 100%" :src="msg_user1_info.avatar" alt="" />
                    </div>
                  </div>

                  <!-- 消息内容 -->
                  <div class="msg_card_content">
                    <div :class="msg_info.status == 'receive'
                      ? 'msg_card_content_inner'
                      : 'msg_card_content_inner_right'
                      ">
                      <div :class="msg_info.status == 'receive'
                        ? 'msg_template_card'
                        : 'msg_template_card2'
                        " v-if="msg_info.msg_type == 'template'">
                        <div class="template_title">
                          {{ msg_info.data.title }}
                        </div>
                        <div>
                          <div v-for="(item, i) in msg_info.data.data" :key="i" class="template_field_div">
                            <div class="template_field">{{ item.label }}：</div>
                            <div class="template_value">
                              {{ item.value }}
                            </div>
                          </div>
                        </div>
                        <div class="jump_btn_div" v-if="msg_info.jump_title">
                          <div @click="click_template_jump_btn(msg_info, jump_item)" class="jumpbtn"
                            :style="'background:' + jump_item.bg_color"
                            v-for="(jump_item, jump_index) in msg_info.jump_title" :key="jump_index">
                            {{ jump_item.title }}
                          </div>
                        </div>
                      </div>

                      <div :class="msg_info.status == 'receive'
                        ? 'msg_template_card'
                        : 'msg_template_card2'
                        " v-if="msg_info.msg_type == 'jump_template'">
                        <div class="template_title">
                          {{ msg_info.data.title }}
                        </div>
                        <div>
                          <div v-for="(item, i) in msg_info.data.data" :key="i" class="template_field_div">
                            <div class="template_field">{{ item.label }}：</div>
                            <div class="template_value">
                              {{ item.value }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div :class="msg_info.status == 'receive'
                        ? 'msg_text_card'
                        : 'msg_text_card2'
                        " v-if="msg_info.msg_type == 'text'">
                        <div class="">
                          {{ msg_info.data.content }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 右侧头像 -->
                  <div class="msg_content_right msg_time_cur">
                    <div class="msg_user_avatar" v-if="msg_info.status == 'sender'">
                      <img style="width: 100%; height: 100%" :src="msg_user2_info.avatar" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="send_msg_input_div">
            <Input v-model="send_msg_value" maxlength="200" show-word-limit type="textarea" placeholder="请输入文本内容..."
              style="width: 100%" />
            <div class="send_msg_btn_div">
              <Button :loading="send_msg_loading" @click="send_message()" size="small" style="font-size: 12px"
                type="primary">
                <Icon type="md-paper-plane" /> 发送消息
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
import ReconnectingWebSocket from "reconnecting-websocket";

export default {
  name: "message_list",
  data() {
    return {
      show: true,
      user_index: 0,

      msg_user1_info: {
        name: "呵呵",
        avatar:
          "https://img0.baidu.com/it/u=189649806,2789154204&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
      },
      msg_user2_info: {
        name: "呵呵2",
        avatar:
          "https://img2.baidu.com/it/u=1790834130,1952230725&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
      },

      user_msg_list: [],
      msg_data_list: [],
      current_user_item: {},
      msg_timer_list: [],
      send_msg_value: "",
      send_msg_loading: false,
      // 消息加载提示
      msg_content_loading: false,

      //   ws实例
      rws: {},
      //
    };
  },

  mounted() {
    this.get_user_message_list();
  },

  beforeDestroy() {
    // 在组件销毁前清除定时器
    this.timer.map((item) => {
      clearInterval(item);
    });
    this.msg_timer_list = [];
  },

  methods: {
    click_template_jump_btn(msg_info, jump_item) {
      console.log(msg_info, jump_item);

      var that = this;
      var obj = {
        message_id: msg_info.message_id,
        jump_item: jump_item,
      };
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/message/v1/template_jump",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            // that.$Message.success({
            //   content: res.msg,
            //   duration: 3,
            // });
            open_new_page(res.data.url);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.send_msg_loading = false;
        });
    },

    send_message() {
      console.log(this.current_user_item);
      if (this.send_msg_value.length == 0) {
        this.$Message.error("请输入内容");
        return;
      }
      var that = this;
      var obj = {
        message_type: "text",
        message_data: {
          content: this.send_msg_value,
          receive_id: this.current_user_item.sender_id,
        },
      };
      that.send_msg_loading = true;
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/message/v1/send_message",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.send_msg_value = "";
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.send_msg_loading = false;

          that.get_message_detail(this.current_user_item.sender_id, true);
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.send_msg_loading = false;
        });
    },

    //页面关闭
    drawer_close() {
      console.log("页面关闭，停止轮循");

      this.msg_timer_list.map((item) => {
        clearInterval(item);
      });
      this.msg_timer_list = [];
      this.user_index = 0;
    },

    get_message_detail(sender_id, is_scrool) {
      var that = this;
      var obj = {
        sender_id: sender_id,
        platform: 'WEB'
      };
      this.msg_content_loading = true;
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/message/v1/msg_detail",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res)
            that.msg_data_list = res.data.data_list;
            that.msg_user1_info = res.data.sender_user_info;
            that.msg_user2_info = res.data.receiver_user_info;
            if (is_scrool === true) {
              console.log("要滚动");
              setTimeout(() => {
                let scroll_to_bottom = document.getElementById("msg_content");
                scroll_to_bottom.scrollTop = scroll_to_bottom.scrollHeight;
              }, 500);
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.msg_content_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 获取用户的消息列表
    get_user_message_list() {
      var that = this;
      var obj = {
        platform: 'WEB'
      };
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/message/v1/msg_list",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.user_msg_list = res.data.msg_list;
            if (that.user_msg_list.length > 0 && that.user_index == 0) {
              that.current_user_item = that.user_msg_list[0];
              that.get_message_detail(that.current_user_item.sender_id, true);
            } else {
              console.log("定时刷新详情页");
              that.get_message_detail(that.current_user_item.sender_id, true);
            }
          } else {
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_msg_card(item, index) {
      console.log(item);
      item.count = 0;
      this.current_user_item = item;
      this.user_index = index;
      this.get_message_detail(item.sender_id, true);
    },

    click_del_msg(item) {
      console.log(item);
      var that = this;
      var obj = {
        sender_id: item.sender_id,
      };
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/message/v1/del_list",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success(res.msg);
            that.get_user_message_list();
          } else {
            that.$Message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //删除小红点
    click_clear_red_dot() {
      var that = this;
      var obj = {
        platform: 'WEB'
      };
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/message/v1/clear_red_dot",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success(res.msg);
          } else {
            that.$Message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    // 获取消息数量
    get_msg_count() {
      var that = this;
      var dx_token = this.$cookies.get("dx_token");
      const url =
        process.env.VUE_APP_V2_AUTH_MESSAGE_WS +
        "/message/ws/message_count?platform=WEB&token=" +
        dx_token;
      console.log(url);
      const protocols = []; // 可选的子协议数组
      const options = {
        // 自动重新连接的选项（可选）
        connectionTimeout: 2000,
        maxRetries: 10,
      };

      that.rws = new ReconnectingWebSocket(url, protocols, options);

      // 当连接成功建立时
      that.rws.addEventListener("open", function (event) {
        console.log("Connected to the WebSocket server");
      });

      // 当接收到消息时
      that.rws.addEventListener("message", function (event) {
        // console.log("Received message:", event.data);
        var msg_data = JSON.parse(event.data);
        var msg_count = msg_data.msg_count;
        var old_msg_count = that.$cookies.get("dx_msg_count");
        that.$cookies.set("dx_msg_count", msg_count);
        if (msg_count > old_msg_count) {
          console.log("消息声音通知", msg_count, old_msg_count);
          that.$emit("change", "play_notify_mp3");
          console.log("重新加载消息列表页");
          that.get_user_message_list();
        }
      });

      // 当连接关闭时
      that.rws.addEventListener("close", function (event) {
        console.log("Disconnected from the WebSocket server");
      });

      // 当发生错误时
      that.rws.addEventListener("error", function (event) {
        console.error("WebSocket encountered error:", event.error);
      });
    },

    refresh() {
      this.get_user_message_list();
    },

    open() {
      // this.show = true;
      var that = this;
      this.msg_timer_list.map((item) => {
        clearInterval(item);
      });


      that.get_user_message_list();
      that.get_msg_count();
      // if (this.msg_timer_list.length == 0) {
      //   var msg_intervalId = setInterval(() => {
      //     //获取消息列表
      //     that.get_user_message_list();
      //   }, 5000);
      //   this.msg_timer_list.push(msg_intervalId);
      // }
    },
  },
};
</script>

<style scoped>
.notify_mp3_url {
  display: none;
}

.clear_red_dot:hover {
  color: rgb(228, 32, 32);
  cursor: pointer;
}

.clear_red_dot {
  color: #a0a0a0
}

.del_msg_list {
  position: absolute;
  right: 5px;
  top: 5px;
  color: #fbefef;
}

.del_msg_list:hover .del_msg_icon {
  color: #f13535;
}

.jump_btn_div {
  display: flex;
  align-items: center;
}


.jumpbtn {
  width: 100%;
  min-width: 80px;
  margin: 10px 5px 5px 0;
  padding: 5px 10px;
  color: #fff;
  background: #0466ddcc;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  text-align: center;
}

.jumpbtn:hover {
  opacity: 0.8;
}

.msg_bg {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.05;
}

.demo-spin-col .circular {
  width: 25px;
  height: 25px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
  color: #040fdd;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.msgname1 {
  padding-left: 5px;
}

.msgname {
  padding: 5px;
  text-align: center;
  background: #e6ebef;
  border-bottom: 1px solid #ddd;
  color: #666;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-badge-alone {
  position: absolute !important;
  top: -2;
}

.msg_time_span {
  padding: 3px 5px;
  color: #c5c5c5;
  border-radius: 3px;
}

.msg_time:hover {
  cursor: pointer;
}

.msg_time:hover .msg_time_span {
  /* background: #0466dd; */
  color: #888;
}

.msg_time {
  text-align: center;
  font-size: 12px;
  color: #eaeaea;
  margin-bottom: 5px;
  padding-top: 5px;
  border-top: 1px solid #dee2eb;
}

.template_field_div {
  display: flex;
}

.template_title {
  font-size: 14px;
  margin-bottom: 10px;
}

.template_value {
  font-size: 13px;
}

.template_field {
  width: 80px;
  font-size: 13px;
  flex-shrink: 0;
}

.msg_content_left {
  width: 55px;
  height: 100%;
  flex-shrink: 0;
}

.msg_content_right {
  width: 55px;
  height: 100%;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
}

.msg_user_avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #f9f8f8;
}

.msg_card_content {
  width: 100%;
}

.msg_card_content_inner {
  max-width: 100%;
  display: flex;
}

.msg_card_content_inner_right {
  max-width: 100%;
  display: flex;
  justify-content: flex-end;
}

.msg_text_card {
  background: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0 0 3px #e6e6e6;
  white-space: pre-wrap;
}

.msg_text_card2 {
  background: #2676e8;
  color: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0 0 3px #e6e6e6;
  white-space: pre-wrap;
}

.msg_template_card {
  background: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0 0 3px #e6e6e6;
}

.msg_template_card2 {
  background: #2676e8;
  padding: 10px 15px;
  color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 3px #e6e6e6;
}

.msg_content_inner {}

.msg_content_inner2 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.msg_content {
  height: calc(100% - 60px);
  overflow: auto;
  padding: 10px;
  background-image: linear-gradient(rgba(230, 235, 239, 0.875),
      rgba(230, 235, 239, 0.875)),
    url("@/assets/image/auth/logo.png");
  background-size: 308px 56px;
  /* 背景图片覆盖整个元素 */
  background-repeat: no-repeat;
  /* 背景图片不重复 */
  background-position: center;
  /* 背景图片居中 */
}

.user_info_box {
  margin: 10px;
  height: 50px;
  background: #fff;
}

.send_msg_input_div {
  padding-top: 3px;
}

.send_msg_btn_div {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-right: 10px;
}

.msg_right {
  height: calc(100% - 100px);
  background: #e6ebef;
  width: calc(100vw - 100px);
  position: relative;
}

.msg_header_detail {
  font-size: 13px;
  color: #ccc;
}

.msg_header_title {
  font-size: 14px;
  font-weight: 600;
  color: rgb(50, 50, 50);
  font-family: "DingTalk_JinBuTi";
}

.msg_header {
  height: 60px;
  background: #ffffff;
  width: 100%;
  font-size: 16px;
  color: #000;
  padding: 10px 10px;
  border-bottom: 1px solid #dedede;
}

.msg_title {
  font-family: "DingTalk_JinBuTi";
  font-size: 13px;
  color: #333;
  width: 195px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.no_msg{
  position: absolute;
  top:7px;
  right:23px
}

.msg_title-1 {
  font-family: "DingTalk_JinBuTi";
  font-size: 13px;
  color: #333;
  width: 195px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.msg_detail {
  width: 180px;
  font-size: 12px;
  color: #bababa;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.avatar_img {
  width: 100%;
  height: 100%;
}

.avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: #0466dd; */
  border: 1px solid #eae4e4;
  border-radius: 5px;
  overflow: hidden;
  margin-right: 10px;
}

.msg_title2 {
  position: relative;
  top: -3px;
}

.msg_card_select {
  height: 60px;
  padding: 10px;
  background: #ededed;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
  position: relative;
}

.msg_card {
  cursor: pointer;
  height: 60px;
  padding: 10px 10px 10px 10px;
  background: #ffffff;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f1f1f1;
  position: relative;
}

.msg_card:hover {
  cursor: pointer;
  background: #f5f5f5;
}

:deep(.ivu-modal-header) {
  padding: 0;
}

.message_div {
  height: calc(100vh - 0px);
  overflow: auto;
  display: flex;
}

.msg_left {
  width: 280px;
  flex-shrink: 0;
  height: 100%;
  overflow: auto;
  background: #fff;
  border-right: 1px solid #ccc;
}

.msg {
  width: calc(100vw - 130px);
  display: flex;
}

.header {
  height: 25px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
}
</style>
